import { RouteType } from "types/RouteType";
import estimatingDashboardRoute from "./Dashboard/EstimatingDashboard.Route";

const estimatingRoutesList: RouteType[] = [
  estimatingDashboardRoute,
];

export default estimatingRoutesList;